<template>
  <ul class="ui-news-list-hina">
    <li v-for="content in data" :key="content.id">
      <UiNewsListRow
        :url="content.path"
        :date="ldate(content.date)"
        :title="ls(content.title)"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
interface Props {
  data: Page[]
}

withDefaults(defineProps<Props>(), {})

const { ls, ldate } = useI18n()
</script>

<style lang="scss" scoped>
.ui-news-list-hina {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
</style>
